import React from "react";
import { Route, Routes } from "react-router-dom";
import { ROUTE_PATHS } from "../routes/routePath";
import { routes } from "../routes/routes";
import { AdminSingin } from "./pages/login/AdminSingin";
import { Singin } from "./pages/login/Singin";
import ProtectedRoute from "./pages/login/protectedRoute";
import { Singup } from "./pages/signup/Singup";
import TwoFALogin from "./pages/login/TwoFALogin";
import SubscriptionChoices from "./pages/subscribe/Subscribe";
import { ForgotPassword } from "./pages/forgot/ForgotPassword";
import { ResetPassword } from "./pages/forgot/ResetPassword";

export const Root = () => {
  const routeMapping = (path, Component, exact, nestedRoutes, index) => {
    return (
      <Route path={path} element={<Component />} exact={exact} key={index}>
        {nestedRoutes &&
          nestedRoutes.map(({ path, Component, exact, nestedRoutes }, index) =>
            routeMapping(path, Component, exact, nestedRoutes, index)
          )}
      </Route>
    );
  };

  return (
    <Routes>
      <Route path="/" element={<Singin />} />
      <Route path={ROUTE_PATHS.ADMIN_LOGIN} element={<AdminSingin />} />
      <Route path={ROUTE_PATHS.SIGNUP} element={<Singup />} />
      <Route path={ROUTE_PATHS.SUBSCRIBE} element={<SubscriptionChoices />} />
      <Route path={ROUTE_PATHS.TWO_FA} element={<TwoFALogin />} />
      <Route path={ROUTE_PATHS.FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTE_PATHS.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path="/" element={<ProtectedRoute />}>
        {routes.map(({ path, Component, exact, nestedRoutes }, index) =>
          routeMapping(path, Component, exact, nestedRoutes, index)
        )}
      </Route>
    </Routes>
  );
};
